import type { I18n } from './types'

export const defaultI18n: I18n = {
  optional: ' (optional)',
  required: '',
  add: 'Add',
  remove: 'Remove',
  up: 'Up',
  down: 'Down',
}
